import React from 'react';

const FootstepsIcon = ({ className = 'w-6 h-6' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M8.5 6.5c0 2.6-1.2 4.7-2.8 4.7S3 9.1 3 6.5 4.2 2 5.7 2s2.8 1.9 2.8 4.5Z" />
    <path d="M8.2 13.3c0 1.5-.9 2.7-2 2.7s-2-1.2-2-2.7.9-2.7 2-2.7 2 1.2 2 2.7Z" />
    <path d="M21 10.2c0 3-1.3 5.3-3.1 5.3s-3.1-2.3-3.1-5.3S16.2 5 17.9 5 21 7.2 21 10.2Z" />
    <path d="M18.1 19.1c0 1.6-1 2.9-2.2 2.9s-2.2-1.3-2.2-2.9 1-2.9 2.2-2.9 2.2 1.3 2.2 2.9Z" />
  </svg>
);

export default FootstepsIcon;
